export const RRS_CREDIT_CARD_LOAN = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Kredittkortlån? Da kan det lønne seg å refinansiere',
  url: 'https://scoopr.no/kredittkortlan',
  description:
    'Har du flere kredittkort med mye gjeld? Du kan spare titusener hvert år på å refinansiere til ett lån – det tar deg kun to minutter å søke.',
  datePublished: '2022-01-04T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
